import { render, staticRenderFns } from "./app-callouts.vue?vue&type=template&id=0ec558d3&"
import script from "./app-callouts.vue?vue&type=script&lang=js&"
export * from "./app-callouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports